module.exports = __webpack_public_path__ + "img/person_hxm.02944b99.jpg";